export default {"src":"/_next/static/media/CECA_ICONOS_Hogar-CasaSillonTV-17.01728bb8.svg","height":160,"width":545,"blurWidth":0,"blurHeight":0};